module.exports = __webpack_public_path__ + "img/mail.2a60d7c1.svg";